export const AREA_PICKER_MODAL_ID = 'area-picker-modal';

export const LOADABLE_MODAL_HOOK = 'js-hook-loadable-modal';

export enum NAMED_MODALS {
    AREA_PICKER = 'area-picker-modal',
    MORTGAGE_TOOL = 'mortgage-tool',
    LEAD_FORM = 'lead-form',
    BROCHURE_FORM = 'brochure-form',
    NEWSLETTER_FORM = 'newsletter-form',
    MESSAGE_FORM = 'message-form-modal',
    HOUSING_MODULE = 'housing-module',
    MORTGAGE_TOOL_RABO = 'mortgage-tool-rabo',
}
